import { FormattedMessage } from 'react-intl';

import { DialogProps, DialogTitle, List } from '@mui/material';

import { AccountBalanceV2, AccountId } from '@arrived/models';
import { useGetAccountBalanceQuery } from '@arrived/queries';

import { DataStateHandler } from '../../../DataStateHandler';
import { PortfolioDialog } from './PortfolioDialog';

import { RentalIncomeDetailsList } from '../../common/detailsList';

export interface RentalIncomeDialogProps extends DialogProps {
  accountId?: AccountId;
}

export const RentalIncomeDialog = ({ accountId, ...rest }: RentalIncomeDialogProps) => {
  const accountBalanceState = useGetAccountBalanceQuery(accountId);

  return (
    <PortfolioDialog {...rest}>
      <DataStateHandler queries={[accountBalanceState]}>
        {(accountBalanceState) => <RentalIncomeDialogContent accountBalance={accountBalanceState.data} />}
      </DataStateHandler>
    </PortfolioDialog>
  );
};

interface RentalIncomeDialogContentProps {
  accountBalance: AccountBalanceV2;
}

const RentalIncomeDialogContent = ({ accountBalance }: RentalIncomeDialogContentProps) => {
  const {
    rentalIncome: { blendedAnnualDividendPercent, latestDividend, totalDividendsPaid },
  } = accountBalance;

  return (
    <>
      <DialogTitle>
        <FormattedMessage id="rental-income" defaultMessage="Rental Income" />
      </DialogTitle>
      <List>
        <RentalIncomeDetailsList
          allTimeDividends={totalDividendsPaid}
          prevDividend={latestDividend?.totalDividendsPaid}
          prevDividendDate={latestDividend?.endDate}
          rentalIncomePercent={blendedAnnualDividendPercent}
        />
      </List>
    </>
  );
};
